module.exports = __webpack_public_path__ + "img/sec_phone5.94a371da.png";